// @flow

import React from 'react';
import ResultCard from 'components/ResultCard/ResultCard.js';
import ResultCardContainer from 'components/ResultCardContainer/ResultCardContainer.js';
import ResultData from 'components/ResultData/ResultData.js';
import { formatedDuration } from 'services/format/formatDuration';

import './PenaltyTimeBoard.scss';

type Props = {
  formatMessage: Function,
  penaltyTime: string
}

const PenaltyTimeBoard = ({ formatMessage, penaltyTime }: Props) => {
  const displayPenaltyTime = penaltyTime ? formatedDuration(penaltyTime) : '--';

  return (
    <ResultCardContainer className="margin-bottom">
      <ResultCard logo="icon-penalty">
        <ResultData
          type={formatMessage('page.participant.participantHeader.penaltyTime')}
          data={displayPenaltyTime}
          dataFont={20} />
      </ResultCard>
    </ResultCardContainer>
  );
};

export default PenaltyTimeBoard;
